import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
import AddButton from '../addButton';
var ReactSuperSelect = require('react-super-select')

class DynamicMysql extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			editing: false,
			deleting: false,
			loading: false,
			view: false,
			filterBy: {},
			sortBy: '',
			sortOrder: 1,
			rows: [],
			rowsTotal: 0,
			sortBy: '',
			sortOrder: 1
		};
	}

	edit = (item) => (e) => {
		if (!item) {
			this.setState({ editing: {} })
		} else {
			this.setState({ editing: JSON.parse(JSON.stringify(item)) })
		}
	}

	delete = (item) => (e) => {
		e.stopPropagation()
		this.setState({ deleting: item })
	}

	confirm = (e) => {
		if (this.state.editing) {
			let errorFound = false;

			//dynamic condition definitions
			for (let i of this.props.data[this.state.view].schema) {
				if (i['conditions']) {
					if (i['conditions']['required'] && !this.state.editing[i['name']]) {
						this.setState({ error: 'The ' + i['name'] + ' field is required' });
						errorFound = true;
					} else if (i['conditions']['dateAfter'] && new Date(this.state.editing[i['name']]) < new Date(this.state.editing[i['conditions']['dateAfter']])) {
						this.setState({ error: 'The ' + i['name'] + ' field must be after the ' + i['conditions']['dateAfter'] });
						errorFound = true;
					} else if (i['conditions']['dateBefore'] && new Date(this.state.editing[i['name']]) > new Date(this.state.editing[i['conditions']['dateBefore']])) {
						this.setState({ error: 'The ' + i['name'] + ' field must be before the ' + i['conditions']['dateBefore'] });
						errorFound = true;
					} else if (i['conditions']['equalTo'] && this.state.editing[i['name']] != this.state.editing[i['conditions']['equalTo']]) {
						this.setState({ error: 'The ' + i['name'] + ' field must be equal to ' + i['conditions']['equalTo'] });
						errorFound = true;
					}
				}
			}

			if (!errorFound) {
				this.setState({ loading: true });
				this.props.ws.send(JSON.stringify({ route: 'dynamicMysqlAddEditItem', module: this.state.view, item: this.state.editing }))
			}

		} else if (this.state.deleting) {
			this.setState({ loading: true });
			this.props.ws.send(JSON.stringify({ route: 'dynamicMysqlDeleteItem', module: this.state.view, item: this.state.deleting }))
		}
	}

	cancel = (e) => {
		this.setState({ editing: false, deleting: false, loading: false, error: false })
	}
	toggle = (field) => (e) => {
		var newState = this.state.editing
		newState[field] = newState[field] ? false : true
		this.setState({ editing: newState })
	}
	valueChange = (field, type, parentList, index) => (e) => {
		var newState = this.state.editing
		if (!parentList) {
			if (type == 'string') {
				newState[field] = e.currentTarget.value
			} else if (type == 'longString') {
				newState[field] = e.currentTarget.value
			} else if (type == 'phone') {
				newState[field] = e.currentTarget.value.replace(/\D/gm, '').substr(0, 10)
			}
		} else if (parentList) {
			if (type == 'string') {
				newState[parentList][index][field] = e.currentTarget.value
			} else if (type == 'longString') {
				newState[parentList][index][field] = e.currentTarget.value
			} else if (type == 'phone') {
				newState[parentList][index][field] = e.currentTarget.value.replace(/\D/gm, '').substr(0, 10)
			}
		}


		this.setState({ editing: newState })
	}
	addListItem = (param) => (e) => {
		var newState = JSON.parse(JSON.stringify(this.state.editing))

		var newObject = {}
		for (var field of param.schema) {
			newObject[field.name] = ""
		}
		if (!newState.hasOwnProperty(param.name)) {
			newState[param.name] = []
		}
		newState[param.name].push(newObject)

		this.setState({ editing: newState })
	}

	removeListItem = (param, index) => (e) => {
		var newState = JSON.parse(JSON.stringify(this.state.editing))

		if (!newState.hasOwnProperty(param.name)) {
			newState[param.name] = []
		}
		newState[param.name].splice(index, 1)

		this.setState({ editing: newState })
	}

	timeSelect = (field) => (datetime) => {

		var newState = this.state.editing

		if (datetime && Math.abs(new Date().getTime() - datetime[0].getTime()) < 1000) {
			newState[field] = '12:00'
		} else if (datetime) {
			newState[field] = datetime[0].getHours() + ':' + datetime[0].getMinutes()
		} else {
			delete newState[field]
		}

		this.setState({ editing: newState })
	}
	clearDateTime = (field) => (e) => {
		var newState = this.state.editing
		delete newState[field]
		this.setState({ editing: newState })
	}
	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.confirm();
		}
	}
	componentWillMount() {
		for (var module in this.props.data) {
			if (this.props.data[module] && this.props.data[module].hasOwnProperty('schema')) {
				this.setState(
					{ view: module, sortBy: this.props.data[module].sortBy },
					() => this.loadRows()
				)
			}
		}

		if (this.refreshTimer) {
			clearInterval(this.refreshTimer);
		}
	}

	componentDidMount_old() {
		this.refreshTimer = setInterval(() => {
			if (!this.state.editing && !this.state.deleting && this.state.view) {
				this.loadRows();
			}
		}, 15000); // every 15 seconds
	}

	componentDidMount() {
		if (this.props.active) {
			this.startRefreshing();
		}
	}
	
	componentDidUpdate(prevProps) {
		// user switched onto this view
		if (!prevProps.active && this.props.active) {
			this.startRefreshing(true); // true = load immediately
		}
	
		// user switched away from this view
		if (prevProps.active && !this.props.active) {
			this.stopRefreshing();
		}
	}
	
	componentWillUnmount() {
		this.stopRefreshing();
	}
	
	startRefreshing = (loadNow = false) => {
		if (this.refreshTimer) return;
	
		if (loadNow) {
			this.loadRows();
		}
	
		this.refreshTimer = setInterval(() => {
			if (this.props.active && !this.state.editing && !this.state.deleting) {
				this.loadRows();
			}
		}, 30000);
	}
	
	stopRefreshing = () => {
		if (this.refreshTimer) {
			clearInterval(this.refreshTimer);
			this.refreshTimer = null;
		}
	}

	componentWillReceiveProps() {
		if (this.state.loading) {
			this.cancel()
		}
	}

	loadRows = () => {
		const view = this.state.view;

		this.setState({ loadingRows: true });

		this.props.ws.send(JSON.stringify({
			route: 'dynamicMysqlGetRows',
			path: view,
			module: this.props.data[module]
		}));
	};


	getFieldLabel = (param) => {
		return param && (param.displayName ? param.displayName : param.name);
	}

	getEditingValue = (param, parentList, index) => {
		if (!param || !param.name) return '';
		if (parentList) {
			return this.state.editing && this.state.editing[parentList] && this.state.editing[parentList][index]
				? this.state.editing[parentList][index][param.name]
				: '';
		}
		return this.state.editing ? this.state.editing[param.name] : '';
	}

	renderFieldRow = (param, control, options = {}) => {
		const rowStyle = {
			borderBottom: options.borderBottom === false ? 'none' : '1px solid #d9e3ef'
		};
		const labelStyle = {
			width: '50%',
			minWidth: '280px',
			maxWidth: '520px',
			fontWeight: '600',
			fontSize: '0.95em',
			color: '#234',
			padding: '10px 18px 10px 0',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			textAlign: 'right',
			verticalAlign: options.alignItems === 'flex-start' ? 'top' : 'middle'
		};
		const valueStyle = {
			padding: '10px 0',
			textAlign: options.alignItems === 'flex-start' ? 'top' : 'left',
			minWidth: '280px',
			width: '50%'
		};
		return (
			<tr key={options.key || ('fieldRow_' + (param && param.name ? param.name : Math.random()))} style={rowStyle}>
				<th style={labelStyle} title={this.getFieldLabel(param)}>
					{this.getFieldLabel(param)}
				</th>
				<td style={valueStyle}>
					<div style={{ display: 'inline-flex', justifyContent: 'flex-start', alignItems: options.alignItems || 'center', maxWidth: '100%' }}>
						{control}
					</div>
				</td>
			</tr>
		);
	}

	renderDynamicInput = (param, value, parentList, index, renderOptions = {}) => {
		if (param instanceof Array) {
			return (
				<div key={'groupInput_' + index + '_' + param.map((item) => item.name).join('_')}>
					{param.map((subItem, subIndex) => this.renderDynamicInput(subItem, this.getEditingValue(subItem, parentList, index), parentList, index, { borderBottom: subIndex < param.length - 1 }))}
				</div>
			);
		}

		const readOnly = param.readOnly ? param.readOnly : false;
		const currentValue = typeof value === 'undefined' ? this.getEditingValue(param, parentList, index) : value;
		const inputValue = currentValue === null || typeof currentValue === 'undefined' ? '' : currentValue;
		const inputStyle = { border: '1px solid #2A6AA9', padding: '10px 12px', width: '100%', boxSizing: 'border-box' };
		const shortInputStyle = { ...inputStyle, maxWidth: '260px' };
		const textareaStyle = { ...inputStyle, minHeight: '90px', resize: 'vertical' };

		if (param.type == 'string' || param.type == 'phone' || param.type == 'static') {
			const disabled = readOnly || param.type == 'static';
			return this.renderFieldRow(
				param,
				<input
					className="textInput"
					type="text"
					required
					value={inputValue}
					disabled={disabled}
					onChange={disabled ? undefined : this.valueChange(param.name, param.type, parentList, index)}
					style={shortInputStyle}
				/>,
				{ key: 'inputDiv' + param.name, borderBottom: renderOptions.borderBottom }
			);
		}

		if (param.type == 'longString') {
			return this.renderFieldRow(
				param,
				<textarea
					className="bigTextInput"
					required
					value={inputValue}
					disabled={readOnly}
					onChange={readOnly ? undefined : this.valueChange(param.name, param.type, parentList, index)}
					style={textareaStyle}
				/>,
				{ key: 'inputDiv' + param.name, alignItems: 'flex-start', borderBottom: renderOptions.borderBottom }
			);
		}

		if (param.type == 'date') {
			const onChange = readOnly ? undefined : (date, { name = param.name }) => {
				const nextEditing = JSON.parse(JSON.stringify(this.state.editing || {}));
				if (parentList) {
					if (!nextEditing[parentList]) nextEditing[parentList] = [];
					if (!nextEditing[parentList][index]) nextEditing[parentList][index] = {};
					nextEditing[parentList][index][name] = date && date[0] ? [date[0]] : '';
				} else {
					nextEditing[name] = date && date[0] ? [date[0]] : '';
				}
				this.setState({ editing: nextEditing });
			};
			return this.renderFieldRow(
				param,
				<Flatpickr disabled={readOnly} style={shortInputStyle} options={{ dateFormat: "Y-m-d" }} value={currentValue} onChange={onChange} />,
				{ key: 'inputDiv' + param.name, borderBottom: renderOptions.borderBottom }
			);
		}

		if (param.type == 'datetime') {
			const displayValue = readOnly && currentValue ? new Date(currentValue).toLocaleString() : currentValue;
			const control = readOnly ? (
				<input className="textInput" type="text" required value={displayValue || ''} disabled={true} style={{ ...shortInputStyle, maxWidth: '320px' }} />
			) : (
				<div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'nowrap', minHeight: '42px', width: '100%' }}>
					<Flatpickr
						disabled={readOnly}
						style={{ ...shortInputStyle, maxWidth: '320px' }}
						options={{ enableTime: true, noCalendar: false, time_24hr: true, dateFormat: "Y-m-d H:i:S", allowInput: true }}
						value={currentValue}
						onChange={(dates) => {
							const nextEditing = JSON.parse(JSON.stringify(this.state.editing || {}));
							if (parentList) {
								if (!nextEditing[parentList]) nextEditing[parentList] = [];
								if (!nextEditing[parentList][index]) nextEditing[parentList][index] = {};
								nextEditing[parentList][index][param.name] = dates && dates[0] ? [dates[0]] : '';
							} else {
								nextEditing[param.name] = dates && dates[0] ? [dates[0]] : '';
							}
							this.setState({ editing: nextEditing });
						}}
					/>
					{currentValue ? (
						<div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', height: '42px' }} onClick={this.clearDateTime(param.name)}>X</div>
					) : null}
				</div>
			);
			return this.renderFieldRow(param, control, { key: 'inputDiv' + param.name, borderBottom: renderOptions.borderBottom });
		}

		if (param.type == 'startDate' || param.type == 'endDate') {
			const endOfDay = param.type == 'endDate';
			const disabled = param.type == 'endDate' ? true : readOnly;
			const onChange = readOnly ? undefined : (date, { name = param.name }) => {
				const adjusted = date && date[0]
					? [new Date(new Date(date[0]).setHours(endOfDay ? 23 : 0, endOfDay ? 59 : 0, endOfDay ? 59 : 0, 0))]
					: '';
				const nextEditing = JSON.parse(JSON.stringify(this.state.editing || {}));
				if (parentList) {
					if (!nextEditing[parentList]) nextEditing[parentList] = [];
					if (!nextEditing[parentList][index]) nextEditing[parentList][index] = {};
					nextEditing[parentList][index][name] = adjusted;
				} else {
					nextEditing[name] = adjusted;
				}
				this.setState({ editing: nextEditing });
			};
			return this.renderFieldRow(
				param,
				<Flatpickr disabled={disabled} style={shortInputStyle} options={{ dateFormat: "Y-m-d h:i K" }} value={currentValue} onChange={onChange} />,
				{ key: 'inputDiv' + param.name, borderBottom: renderOptions.borderBottom }
			);
		}

		if (param.type == 'boolean') {
			return this.renderFieldRow(
				param,
				<div className="activeBox" style={{ cursor: readOnly ? "not-allowed" : "pointer", opacity: readOnly ? 0.6 : 1 }} onClick={readOnly ? undefined : this.toggle(param.name)}>
					<div className={currentValue ? "enabled" : "disabled"}></div>
				</div>,
				{ key: 'inputDiv' + param.name, borderBottom: renderOptions.borderBottom }
			);
		}

		if (param.type == 'timeOfDay') {
			return this.renderFieldRow(
				param,
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
					<Flatpickr disabled={readOnly} style={shortInputStyle} options={{ allowInput: true, dateFormat: "h:i K", noCalendar: true, enableTime: true }} value={currentValue} onChange={readOnly ? undefined : this.timeSelect(param.name)} />
					{currentValue && !readOnly ? <div style={{ cursor: 'pointer' }} onClick={this.clearDateTime(param.name)}>X</div> : ''}
				</div>,
				{ key: 'inputDiv' + param.name, borderBottom: renderOptions.borderBottom }
			);
		}

		if (param.type == 'series') {
			const series = [];
			let stopSeries = false;
			for (var subItem of param.series) {
				if (subItem instanceof Array) {
					let subStopSeries = true;
					for (var subSubItem of subItem) {
						const subValue = this.getEditingValue(subSubItem);
						if (!this.state.editing.hasOwnProperty(subSubItem.name) || subValue === '' || subValue == null) {
							if (!stopSeries) {
								series.push(this.renderDynamicInput(subSubItem, subValue, undefined, undefined));
							}
						} else {
							subStopSeries = false;
							series.push(this.renderDynamicInput(subSubItem, subValue, undefined, undefined));
						}
					}
					if (subStopSeries) stopSeries = true;
				} else {
					const subValue = this.getEditingValue(subItem);
					if (!this.state.editing.hasOwnProperty(subItem.name) || subValue === "" || subValue == null) {
						if (!stopSeries) series.push(this.renderDynamicInput(subItem, subValue, undefined, undefined));
						stopSeries = true;
					} else {
						series.push(this.renderDynamicInput(subItem, subValue, undefined, undefined));
					}
				}
			}
			return <div key={'seriesInput' + param.name}>{series}</div>;
		}

		if (param.type == 'dynamicDropdown') {
			return this.renderFieldRow(
				param,
				<ReactSuperSelect
					disabled={readOnly}
					ajaxDataFetch={() => {
						return new Promise(async (res, rej) => {
							var response = await fetch(window.location.origin + '/data?path=' + param.path);
							if (response.ok) {
								var ddArray = [];
								var ddItems = await response.json();
								for (var ddItem in ddItems) {
									ddArray.push({ id: ddItems[ddItem][param.param], name: ddItems[ddItem][param.param] });
								}
								res(ddArray);
							}
						});
					}}
					initialValue={{ id: this.getEditingValue(param, parentList, index), name: this.getEditingValue(param, parentList, index) }}
					onChange={readOnly ? undefined : this.selectDDDValue(param.name, parentList, index)}
				/>,
				{ key: 'inputDiv' + param.name, borderBottom: renderOptions.borderBottom }
			);
		}

		if (param.type == 'dropdown') {
			const currentId = this.getEditingValue(param, parentList, index);
			const currentOpt = (param.options || []).find(o => String(o.id) === String(currentId));
			return this.renderFieldRow(
				param,
				<ReactSuperSelect
					disabled={readOnly}
					clearable={false}
					dataSource={param.options}
					initialValue={{ id: currentId, name: currentOpt ? currentOpt.name : (currentId ?? "") }}
					onChange={readOnly ? undefined : this.selectDDDValue(param.name, parentList, index)}
				/>,
				{ key: 'inputDiv' + param.name, borderBottom: renderOptions.borderBottom }
			);
		}

		if (param.type == 'list') {
			var list = [];
			if (this.state.editing[param.name] && this.state.editing[param.name].length > 0) {
				for (var [i, subItem] of this.state.editing[param.name].entries()) {
					var listItem = [];
					for (var [fieldIndex, field] of param.schema.entries()) {
						const fieldWithReadOnly = readOnly ? { ...field, readOnly: true } : field;
						listItem.push(this.renderDynamicInput(fieldWithReadOnly, this.state.editing[param.name][i][field.name], param.name, i, { borderBottom: fieldIndex < param.schema.length - 1 }));
					}
					list.push(
						<div key={'listItem_' + param.name + '_' + i} style={{ position: 'relative', border: '1px solid #d9e3ef', padding: '12px 16px', marginBottom: '12px' }}>
							{!readOnly && (<div onClick={this.removeListItem(param, i)} style={{ cursor: 'pointer', position: 'absolute', right: '12px', top: '12px' }}>X</div>)}
							{listItem}
						</div>
					);
				}
			}
			return this.renderFieldRow(
				param,
				<div>
					{list}
					{!readOnly && (<div style={{ width: '150px', margin: '10px 0', cursor: 'pointer', border: '1px solid #2A6AA9', padding: '5px 10px', textAlign: 'center' }} onClick={this.addListItem(param)}>{list.length > 0 ? '+ Add Another' : '+ Add An Item'}</div>)}
				</div>,
				{ key: 'listInput' + param.name, alignItems: 'flex-start', borderBottom: renderOptions.borderBottom }
			);
		}

		return null;
	}


	selectDDDValue = (field, parentList, index) => (valueObject) => {
		var newState = JSON.parse(JSON.stringify(this.state.editing))
		const selectedValue = valueObject && Object.prototype.hasOwnProperty.call(valueObject, 'id')
			? valueObject.id
			: (valueObject && valueObject.name ? valueObject.name : undefined)
		if (parentList) {
			if (selectedValue !== undefined && selectedValue !== null && selectedValue !== '') {
				newState[parentList][index][field] = selectedValue
			} else {
				delete newState[parentList][index][field]
			}
		} else {
			if (selectedValue !== undefined && selectedValue !== null && selectedValue !== '') {
				newState[field] = selectedValue
			} else {
				delete newState[field]
			}
		}

		this.setState({ editing: newState })
	}

	getDisplayIdentifier = (item) => {
		var oneLevelDeeper = (subItem) => {
			if (subItem instanceof Array) {
				return oneLevelDeeper(subItem[0])
			} else {
				return subItem.displayName ? subItem.displayName : subItem.name
			}
		}
		return oneLevelDeeper(this.props.data[this.state.view].schema[0])
	}

	getIdentifier = (item) => {
		var oneLevelDeeper = (subItem) => {
			if (subItem instanceof Array) {
				return oneLevelDeeper(subItem[0])
			} else {
				return subItem.name
			}
		}
		return oneLevelDeeper(this.props.data[this.state.view].schema[0])
	}

	sort = (sortBy) => (e) => {
		var sortOrder
		if (this.state.sortOrder === -1) {
			sortOrder = 1;
		} else {
			sortOrder = -1;
		}
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}

	filter = (field) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[field] = e.target.value
		} else {
			delete filterBy[field]
		}
		this.setState({ filterBy: filterBy })
	}

	filterIcon(item) {
		if (this.state.sortBy !== item) return '';
		return this.state.sortOrder === 1 ? '▲' : '▼';
	}

	flattenDisplaySchema = () => {
		const schema = (this.props.data && this.state.view && this.props.data[this.state.view] && this.props.data[this.state.view].schema) ? this.props.data[this.state.view].schema : [];
		const flat = [];
		for (const param of schema) {
			if (param instanceof Array) {
				for (const subItem of param) {
					if (subItem && subItem.display) flat.push(subItem);
				}
			} else if (param && param.display) {
				flat.push(param);
			}
		}
		return flat;
	}

	flattenFilterSchema = () => {
		const schema = (this.props.data && this.state.view && this.props.data[this.state.view] && this.props.data[this.state.view].schema) ? this.props.data[this.state.view].schema : [];
		const flat = [];
		for (const param of schema) {
			if (param instanceof Array) {
				for (const subItem of param) {
					if (subItem && subItem.showFilter === true) flat.push(subItem);
				}
			} else if (param && param.showFilter === true) {
				flat.push(param);
			}
		}
		return flat;
	}

	truncateDisplayValue = (value, maxLength = 15) => {
		if (typeof value !== 'string') return value;
		return value.length > maxLength ? value.substr(0, maxLength) + '...' : value;
	}

	formatDisplayValue = (item, param) => {
		const value = item ? item[param.name] : '';
		switch (param.type) {
			case 'boolean':
				return value === true ? 'true' : 'false';
			case 'date':
				return value ? new Date(value).toDateString() : '';
			case 'datetime':
				return value ? new Date(value).toLocaleString() : '';
			case 'startDate':
			case 'endDate':
				return value ? new Date(value).toDateString() + ' ' + new Date(value).toLocaleTimeString() : '';
			case 'dropdown': {
				const selectedName = (param.options || []).find(o => o.id === value)?.name ?? '';
				return this.truncateDisplayValue(selectedName);
			}
			default:
				return value === null || typeof value === 'undefined' ? '' : this.truncateDisplayValue(value);
		}
	}

	sortFunc = (sortBy, sortOrder) => {
		return function (a, b) {
			if (sortBy === "status" || sortBy === "ActivityDateTime") {
				if ('status' in a && 'status' in b) {
					if (!a.loggedIn && !b.loggedIn) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					} else if (!a.loggedIn) {
						return 1
					} else if (!b.loggedIn) {
						return -1
					}
					if (a[sortBy] === b[sortBy]) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					}
					return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
				} else {
					if ('status' in a) {
						return -1
					}
					return 1
				}
			}

			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
			} else {
				return sortBy in a ? -1 : 1
			}
		}
	}

	filterFunc = (array, filterBy) => {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (typeof object[prop] === "undefined") {
					return false
				}
				//console.log(object[prop])
				if (object[prop] == null || object[prop] == undefined || object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true;
		})
	}

	render() {
		if (this.props.active) {
			const activeView = this.props.data[this.state.view] || {};
			let items = [];

			for (var id in activeView.data) {
				items.push(activeView.data[id]);
			}

			if (Object.keys(this.state.filterBy).length > 0) {
				items = this.filterFunc(items, this.state.filterBy)
			}

			if (this.state.sortBy !== '') {
				items.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}

			const visibleFields = this.flattenDisplaySchema();
			const filterFields = this.flattenFilterSchema();
			const showFilterBox = filterFields.length > 0;

			const dataList = items.map((item) => (
				<tr
					className="dataRow"
					key={item.id || item[activeView.indexField] || JSON.stringify(item)}
					onClick={activeView.actions && activeView.actions.edit ? this.edit(item) : undefined}
				>
					{visibleFields.map((param) => (
						<td
							key={item.id + '_' + param.name}
							style={{ minWidth: '180px', textAlign: 'left' }}
						>
							{this.formatDisplayValue(item, param)}
						</td>
					))}
					{activeView.actions && activeView.actions.delete ? (
						<td style={{ minWidth: '70px', textAlign: 'right' }}>
							<span className="buttonBox">
								<img src={this.props.img.delete} alt="Delete Row" onClick={this.delete(item)} />
							</span>
						</td>
					) : null}
				</tr>
			));

			var editing, deleting
			if (this.state.editing) {
				var editfields = []
				for (var [idx, param] of activeView.schema.entries()) {
					editfields.push(
						this.renderDynamicInput(param, this.state.editing[param.name], undefined, undefined, { borderBottom: idx < activeView.schema.length - 1 })
					)
				}
				editing = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div
							className="pop"
							style={{
								minWidth: '30vw',
								maxWidth: '90vw',
								maxHeight: '80vh',
								padding: '24px 32px',
								boxSizing: 'border-box',
								display: 'flex',
								flexDirection: 'column',
								gap: '16px'
							}}
						>
							<div style={{ display: 'flex', justifyContent: 'flex-end', flex: '0 0 auto' }}>
								<div className="viewCloser" style={{ position: 'relative', top: 'auto', right: 'auto', display: 'block' }} onClick={this.cancel}></div>
							</div>

							<div
								style={{
									flex: '1 1 auto',
									overflowY: 'auto',
									border: '1px solid #d9e3ef',
									borderRadius: '8px',
									padding: '0 18px',
									paddingBottom: '55px',
									background: '#fff'
								}}
							>
								<table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'auto' }}>
									<tbody>
										{editfields}
									</tbody>
								</table>
							</div>

							<div style={{ flex: '0 0 auto' }}>
								<div className="error" style={{ padding: this.state.error ? '0 0 15px 0' : '0' }}>{this.state.error}</div>
								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirm}>Confirm</div>}
							</div>
						</div>
					</div>
				)
			}

			if (this.state.deleting) {
				deleting = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" style={{ width: 'min(1200px, 96vw)', maxWidth: '1200px', padding: '24px 32px', boxSizing: 'border-box' }} >
							<div className="viewCloser" onClick={this.cancel}></div>

							<div>You are removing</div>
							<div style={{ padding: '25px' }}>{this.getDisplayIdentifier(activeView.schema[0])}: {this.state.deleting[this.getIdentifier(activeView.schema[0])]} </div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirm}>Confirm</div>}
						</div>
					</div>
				)
			}

			const addButton = activeView.actions && activeView.actions.add ? <AddButton onClick={this.edit(null)} /> : '';

			return (
				<div width="100%">
					{addButton}
					<div style={{ display: 'flex' }}>
						{showFilterBox ? (
							<div style={{ flex: '0 0 250px', width: '250px', marginRight: '40px', marginTop: '2px' }}>
								<div className="filterBox" style={{ width: '210px' }}>
									<h4>Filter By:</h4>
									{filterFields.map((param) => (
										<div key={'filterBox_' + param.name} style={{ width: '150px' }}>
											<label>{param.displayName ? param.displayName : param.name}:</label>
											<input
												type="text"
												onChange={this.filter(param.name)}
												value={this.state.filterBy[param.name] || ''}
											/>
										</div>
									))}
								</div>
							</div>
						) : null}

						<div style={{ flex: 1, minWidth: 0 }}>
							<div style={{ color: '#137', padding: '5px 10px', fontWeight: '400', fontSize: '20px' }}>
								{'Displaying ' + dataList.length + ' of ' + Object.keys(activeView.data || {}).length + ' Records...'}
							</div>

							<table style={{ float: "left" }}>
								<thead>
									<tr className="dataRow">
										{visibleFields.map((param) => (
											<th
												key={'header_' + param.name}
												style={{ minWidth: '180px', cursor: 'pointer', textAlign: 'left' }}
												onClick={this.sort(param.name)}
											>
												{param.displayName ? param.displayName : param.name} {this.filterIcon(param.name)}
											</th>
										))}
										{activeView.actions && activeView.actions.delete ? (
											<th style={{ minWidth: '70px', textAlign: 'right' }}> </th>
										) : null}
									</tr>
								</thead>
								<tbody>
									{dataList}
								</tbody>
							</table>
						</div>
					</div>
					{editing}
					{deleting}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}

const icon = "menuObject"
export { DynamicMysql, icon }